export const SecuritySettingsTestIds = {
  encryptionSlider: 'encryption_slider',
  buttonVisibilityPrivate: 'button_visibility_private',
  buttonVisibilityPublic: 'button_visibility_public',
  radioHistoryInvited: 'radio_history_invited',
  radioHistoryJoined: 'radio_history_joined',
  radioHistoryShared: 'radio_history_shared',
  radioHistoryWorldReadable: 'radio_history_world_readable',
  buttonSaveSecurity: 'button_save_security'
} as const;
